module.exports = __webpack_public_path__ + "static/media/img.372d7921.png";